var map = {
	"./buy_normal_cn.png": "449e",
	"./buy_normal_en.png": "a613",
	"./buy_normal_id.png": "742c",
	"./buy_normal_ko.png": "5a09",
	"./buy_normal_ph.png": "d3c1",
	"./buy_normal_th.png": "03f6",
	"./buy_normal_zh.png": "7c8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9f4";